import {useEffect,useState} from "react";
import Master from "./Master";

function Gallery(){

      const [photos, setPhotos] = useState([]);

  // fetch photos
  const loadPhotos = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allphoto.php");
    const data = await res.json();
    setPhotos(data);
  };

    useEffect(() => {
      loadPhotos();
    }, []);


    return(
        <Master>
                {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque">Gallery</h1>
						<nav className="wow fadeInUp">
							<ol className="breadcrumb">
								<li className="breadcrumb-item"><a href="./">home</a></li>
								<li className="breadcrumb-item active" aria-current="page">gallery</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

    {/* Photo Gallery Section Start */}
	<div className="our-gallery-page">
		<div className="container">
			{/* gallery section start */}
			<div className="row gallery-items">
                {photos.map((p) => (
                <div className="col-lg-3 col-md-4 col-6" key={p.id}>
                    {/* image gallery start */}
                     
                    <div className="photo-gallery wow fadeInUp" data-cursor-text="View">
                        <a href={p.image}>
                            <figure>
                                <img src={p.image} alt={p.title} />
                            </figure>
                        </a>
                    </div>

                    {/* image gallery end */}
                </div>
                    ))};
			</div>
			{/* gallery section end */}
		</div>
	</div>
	{/* Photo Gallery Section End */}
        </Master>
    );
}

export default Gallery;